import React, { useState } from 'react'
import ReactTooltip from 'react-tooltip';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../../../components/Pagination';
import { Context } from '../../../../config/store';
import LenderUgroService from '../../../../services/lender';
import { toast } from 'react-toastify';
import Modal from '../../../../components/Modal';
import { downloadFile } from '../../../../common/download';

const ApiLogDetails = () => {

  const location = useLocation()
  const navigate = useNavigate()
  const { state, dispatch } = React.useContext(Context);
  const [apiData, setApiData] = React.useState([])
  const leadId = location?.pathname?.split('/')[2]
  const lenderId = location?.pathname?.split('/')[3]
  const leadType = location?.pathname?.split('/')[4]
  const [page, setCurrentPage] = React.useState(1);
  const [pagination, setPagination] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [isLogFailed, setIsLogFailed] = React.useState(false)
  const [modalState, setModalState] = useState(false);
  const [logStatusId, setLogStatusId] = useState(0);
  const [msg, setMsg] = useState('');
  const [loadingId, setLoadingId] = useState(false);

  React.useEffect(() => {
    getApiData();
  }, [])

  const toggleModal = (type=null) => {
    if(type == 0)
      setMsg('Are you sure to make this api success?');
    else if(type == 1)
      setMsg('Do you want to re-run this api?');
    else
      setMsg('');
		setModalState(!modalState);
	};

  const getApiData = async () => {
    setIsLoading(true)
    let res = await LenderUgroService.getApiLogResponses({
      type: state.userType,
      cl_lead_id: leadId,
      cl_lender_id: lenderId,
      lead_type: leadType,
      page: page,
      dataExport: 0
    });
    res?.data?.data?.log_data?.map((item) => {
      item.isSelected = false
      if ((item?.action_type === "response") && (item?.api_status === 0)) {
        setIsLogFailed(true)
      }
    })
    setApiData(res?.data?.data?.log_data)
    setCurrentPage(page);
    setPagination(res?.data?.data?.log_list?.pagination);
    setIsLoading(false)
  }

  const handleShowHide = (itemId) => {
    let data = apiData;
    data?.map((item) => {
      if (item?.id === itemId) {
        item.isSelected = !(item.isSelected)
      } else {
        item.isSelected = false
      }
    })
    setApiData(prevState => [...data])
  }

  const handleReSubmitFailedLogs = async () => {
    setLoading(true)
    try {
      let res = await LenderUgroService.retryFailedApiLogResponses({
        type: state.userType,
        cl_lead_id: leadId,
        cl_lender_id: lenderId,
        page: page,
        dataExport: 0
      });
      if (res?.data?.status?.code === 1) {
        setLoading(false)
        setIsLogFailed(false)
        toast.success(res?.data?.messages?.success?.others[0])
        getApiData()
      }
    } catch (error) {
      toast.error(error?.response?.data?.messages?.error?.others[0] || error?.response?.data?.messages?.success?.others[0])
      setLoading(false)
    }
  }
  const changeApiLogStatus = async (id) => {
    setLoading(true)
    try {
      let res = await LenderUgroService.changeApiLogStatus({
        type: state.userType,
        id: id,
        cl_lender_id: lenderId
      });
      if (res?.data?.status?.code === 1) {
        setLoading(false)
        toggleModal()
        toast.success(res?.data?.messages?.success?.others[0])
        getApiData()
      } else {
        setLoading(false)
        toast.error(res?.data?.messages?.error?.others[0])
      }
    } catch (error) {
      toast.error(error?.response?.data?.messages?.error?.others[0] || error?.response?.data?.messages?.success?.others[0])
      setLoading(false)
    }
  }
  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };

  const downloadGeneratedFile = async (case_id, cl_lead_id, json_data) => {
    try{
    setLoadingId(case_id);
    let file_url = json_data?.file_path;
    const response = await LenderUgroService.downloadCaseFile({
          case_id: case_id,
          cl_lead_id: cl_lead_id,
          file_path: file_url
      });
      const slfileUrl = file_url.split("/");
      downloadFile(response.data, slfileUrl.at(-1));

    } catch (err) {
      toast.error(err.messages);
    }
    setLoadingId(false);
  }
  return (
    <>
      {isLoading ?
        <div className='logsLoaderContainer'>
          <div className="loader"></div>
        </div>
        :
        <div className='mt-1'>
          <div className=''>
            <div className='apilogsHeader'>
              <button
                onClick={() => { navigate(`/api-logs/${lenderId}`) }}
                type='button'
                className='btn btn-outline-custom'
              >
                <i class="fa fa-chevron-left mr-1"></i>
                Back
              </button>
              {
                isLogFailed &&
                <div className="">
                  {checkHasPermission('logs-re-submit-lead') && <button
                    onClick={handleReSubmitFailedLogs}
                    disabled={loading}
                    type='button'
                    className='btn btn-custom'
                  >
                    {!loading ? 'Re-Submit Lead' : <div className="loader"></div>}
                  </button>}
                </div>
              }
            </div>
            <div className='api_log_header'>
              API LOGS
            </div>
            <div className='api_logs_container'>
              {apiData?.length > 0 ?
                apiData?.map((item, index) => {
                  return (
                    <>
                      <div className="chart-card leadRequest mb-2" key={item?.id}>
                        {((item?.action_type === "response") && (item?.api_status === 0)) ?
                          <h2 className='text-danger' onClick={() => { handleShowHide(item?.id) }}>
                            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                              <div>
                                {item?.api_enpoint_name} ({item?.action_type})
                              </div>
                              <div>
                                <span>Created At :  {item?.created_at}</span>
                                {checkHasPermission('logs-re-submit-lead') && item?.action_type === 'response' &&
                                <>
                                <span className="ml-2" data-for='change-api-status1' data-tip style={{"cursor": "pointer"}} onClick={()=> {toggleModal(0); setLogStatusId(item?.id)}}>
                                  <i className={`fa fa-retweet fa-lg text-success`} aria-hidden="true"></i>
                                </span>
                                <ReactTooltip id='change-api-status1'>Change API Log Status</ReactTooltip>
                                </>
                                }
                              </div>
                            </div>
                          </h2> :
                          <h2 className='h5' onClick={() => { handleShowHide(item?.id) }}>
                            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                              <div>
                                {item?.api_enpoint_name} ({item?.action_type})
                              </div>
                              <div>
                                <span>Created At :  {item?.created_at}</span>
                                {checkHasPermission('logs-re-submit-lead') && item?.action_type === 'response' && item?.api_status === 1 &&
                                <>
                                <span className="ml-2" data-for='change-api-status2' data-tip style={{"cursor": "pointer"}} onClick={()=> {toggleModal(1); setLogStatusId(item?.id)}}>
                                  <i className={`fa fa-retweet fa-lg text-danger`} aria-hidden="true"></i>
                                </span>
                                <ReactTooltip id='change-api-status2'>Change API Log Status</ReactTooltip>                                 
                                </>
                                }
                                { (item?.type_id == 1 || item?.type_id == 5) && lenderId == 23 &&
                                  <span
                                  className='mr-2'
                                  onClick={() => downloadGeneratedFile(item?.id, item?.cl_lead_id, item?.json_data)}
                                  disabled={loadingId}
                                  data-tip
                                  data-for='download-document'
                                >
                                   {loadingId === item?.id ? <div className='loader' /> : <span className='ml-2' style={{ cursor: 'pointer' }}><i class="fa fa-cloud-download fa-lg" style={{ color: '#4A4E88' }} aria-hidden="true"></i></span>}
                                </span>
                                }
                              </div>
                            </div>
                          </h2>
                        }

                        {item?.isSelected &&
                          <p>{JSON.stringify(item?.json_data)}</p>
                        }
                      </div>
                    </>
                  )
                })
                :
                <p className='text-center text-danger m-0'>{apiData?.length === 0 && "No Records Found"}</p>
              }
            </div>
          </div>
          <div className="my-2">
            {pagination?.total_pages ? (
              <Pagination
                // disabled={loading}
                // setPage={setCurrentPage}
                total_pages={5}
                total={pagination.total}
                showTotal={true}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      }
      <Modal state={modalState} closeModal={toggleModal} style={{ width: '450px' }} removeBorderSpace={true}>
				<div className='card border-0'>
					<div className="modal-header-container">
						<div className="modal-title">Change API Log Status</div>
						<div className="closeModalView" onClick={toggleModal}>
							<span className="closeModalIcon">x</span>
						</div>
					</div>
					<div className='text-center mt-3'>
            {msg}<br />
					</div>
					<div className='d-flex justify-content-center align-items-center mt-2 mb-3'>
						<button
							type='button'
							className='btn btn-custom'
              disabled={loading}
              style={{'pointerEvents': loading? 'none': 'auto'}}
							onClick={() => changeApiLogStatus(logStatusId)}
						>
              {loading ? <div className='loader' /> : 'Yes'}
						</button>
						<button
							type='button'
							className='btn btn-outline-custom ml-2'
							onClick={toggleModal}
						>
							NO
						</button>
					</div>
				</div>
			</Modal>
    </>
  )
}

export default ApiLogDetails